import { render, staticRenderFns } from "./ModalBundle.vue?vue&type=template&id=164a5acd"
import script from "./ModalBundle.vue?vue&type=script&lang=js"
export * from "./ModalBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports